
// // import { useEffect, useState } from "react";
// // import { useNavigate } from "react-router-dom";
// // import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
// // import { FaXTwitter } from "react-icons/fa6";
// // import { fetchPressReleases } from "../News/pressReleaseApi.js";
// // import { fetchPressCoverages } from "../News/pressCoverageApi.js";
// // import { fetchLeadershipInsights } from "../api/leadershipInsightsApi.js";

// // /* ───────────────────────────────────────────────────────────
// //    COMPONENT
// //    ──────────────────────────────────────────────────────────── */
// // export default function MediaSocialSection() {
// //   // ── Tabs & Social ─────────────────────────────────────────
// //   const [activeTab, setActiveTab] = useState("releases");
// //   const [activeSocial, setActiveSocial] = useState("facebook");

// //   // ── Leadership Insights (ab DB se) ─────────────────────────
// //   const [insights, setInsights] = useState([]);
// //   const [insightsLoading, setInsightsLoading] = useState(true);
// //   const [currentIndex, setCurrentIndex] = useState(0);
// //   const [isHovering, setIsHovering] = useState(false);

// //   // ── Press section hover (scroll pause) ────────────────────
// //   const [isPressHovering, setIsPressHovering] = useState(false);

// //   // ── Backend data ──────────────────────────────────────────
// //   const [pressReleases, setPressReleases] = useState([]);
// //   const [pressCoverage, setPressCoverage] = useState([]);

// //   const navigate = useNavigate();

// //   /* ── Fetch 20 press releases + 20 press coverages ──────── */
// //   useEffect(() => {
// //     let alive = true;

// //     fetchPressReleases()
// //       .then((data) => {
// //         if (!alive) return;
// //         const mapped = data.slice(0, 20).map((pr) => ({
// //           title: pr.title,
// //           date: pr.displayDate,
// //           slug: pr.slug,
// //         }));
// //         setPressReleases(mapped);
// //       })
// //       .catch((err) => console.error("Press releases fetch failed:", err));

// //     fetchPressCoverages()
// //       .then((data) => {
// //         if (!alive) return;
// //         const mapped = data.slice(0, 20).map((pc) => ({
// //           title: pc.title,
// //           date: pc.displayDate,
// //           source: pc.source || "",
// //           externalUrl: pc.externalUrl || "",
// //         }));
// //         setPressCoverage(mapped);
// //       })
// //       .catch((err) => console.error("Press coverage fetch failed:", err));

// //     return () => {
// //       alive = false;
// //     };
// //   }, []);

// //   /* ── Fetch Leadership Insights ──────────────────────────── */
// //   useEffect(() => {
// //     let alive = true;

// //     fetchLeadershipInsights()
// //       .then((data) => {
// //         if (!alive) return;
// //         setInsights(data);
// //       })
// //       .catch((err) => console.error("Leadership insights fetch failed:", err))
// //       .finally(() => {
// //         if (alive) setInsightsLoading(false);
// //       });

// //     return () => {
// //       alive = false;
// //     };
// //   }, []);

// //   /* ── Active tab ke liye list ────────────────────────────── */
// //   const currentList =
// //     activeTab === "releases" ? pressReleases : pressCoverage;
// //   const loopedList = [
// //     ...currentList,
// //     ...currentList,
// //     ...currentList,
// //     ...currentList,
// //   ];

// //   const currentInsight = insights[currentIndex];

// //   /* ── Click handler ──────────────────────────────────────── */
// //   const handleItemClick = (item) => {
// //     if (activeTab === "releases") {
// //       if (item.slug) {
// //         navigate(`/press-release/${item.slug}`);
// //       }
// //     } else {
// //       if (item.externalUrl) {
// //         window.open(item.externalUrl, "_blank", "noopener,noreferrer");
// //       }
// //     }
// //   };

// //   /* ── Auto rotate Leadership Insights (hover pe rukega) ── */
// //   useEffect(() => {
// //     if (insights.length === 0) return;

// //     const interval = setInterval(() => {
// //       if (!isHovering) {
// //         setCurrentIndex((prev) => (prev + 1) % insights.length);
// //       }
// //     }, 8000);
// //     return () => clearInterval(interval);
// //   }, [isHovering, insights.length]);

// //   /* ── Social embeds sirf ek baar load karo ──────────────── */
// //   useEffect(() => {
// //     const timer = setTimeout(() => {
// //       if (window.twttr) window.twttr.widgets.load();
// //       if (window.instgrm) window.instgrm.Embeds.process();
// //     }, 800);
// //     return () => clearTimeout(timer);
// //   }, []);

// //   /* ═══════════════════════════════════════════════════════════
// //      RENDER
// //      ════════════════════════════════════════════════════════════ */
// //   return (
// //     <section className="py-10 bg-[#FAF7F2]">
// //       {/* ── Section Title ──────────────────────────────────── */}
// //       <div className="mb-6 text-center">
// //         <h2 className="mt-2 text-[22px] font-semibold leading-tight font-rethink">
// //           Public Voice{" "}
// //           <span className="italic text-[#da2128]">Digital Presence</span>
// //         </h2>
// //       </div>

// //       <div className="mx-auto px-6">
// //         <div className="flex flex-col lg:flex-row gap-8 h-[520px]">
// //           {/* ══════════════════════════════════════════════════
// //               LEFT – PRESS (Releases / Coverage)
// //               ══════════════════════════════════════════════════ */}
// //           <div
// //             className="lg:w-[490px] bg-[#ffffff] backdrop-blur-lg rounded-3xl p-8 shadow-sm flex flex-col h-full"
// //             onMouseEnter={() => setIsPressHovering(true)}
// //             onMouseLeave={() => setIsPressHovering(false)}
// //           >
// //             {/* Tabs */}
// //             <div className="flex gap-4 mb-8 border-b pb-1">
// //               <button
// //                 onClick={() => setActiveTab("releases")}
// //                 className={`pb-3 text-[14px] font-medium transition-all font-rethink ${
// //                   activeTab === "releases"
// //                     ? "text-[#da2128] border-b-2 border-[#8B0F1A]"
// //                     : "text-gray-500 hover:text-[#8B0F1A]"
// //                 }`}
// //               >
// //                 Press Releases
// //               </button>
// //               <button
// //                 onClick={() => setActiveTab("coverage")}
// //                 className={`pb-3 text-[14px] font-medium transition-all font-rethink ${
// //                   activeTab === "coverage"
// //                     ? "text-[#da2128] border-b-2 border-[#8B0F1A]"
// //                     : "text-gray-500 hover:text-[#8B0F1A]"
// //                 }`}
// //               >
// //                 Press Coverage
// //               </button>
// //             </div>

// //             {/* Scrolling Timeline */}
// //             <div className="relative flex-1 overflow-hidden">
// //               {/* Vertical line */}
// //               <div className="absolute left-6 top-0 bottom-0 w-[2px] bg-[#8B0F1A]/20"></div>

// //               {/* Looping list – hover pe pause */}
// //               <div
// //                 className={`press-loop space-y-8 pr-4 overflow-hidden ${
// //                   isPressHovering ? "paused" : ""
// //                 }`}
// //               >
// //                 {loopedList.map((p, i) => (
// //                   <div key={`${activeTab}-${i}`} className="relative pl-10">
// //                     {/* Dot */}
// //                     <span className="absolute left-6 top-2 -translate-x-1/2 w-3 h-3 bg-[#8B0F1A] rounded-full border-2 border-white"></span>

// //                     {/* Clickable item */}
// //                     <div
// //                       className="group cursor-pointer"
// //                       onClick={() => handleItemClick(p)}
// //                       role="button"
// //                       tabIndex={0}
// //                       onKeyDown={(e) => {
// //                         if (e.key === "Enter" || e.key === " ") {
// //                           handleItemClick(p);
// //                         }
// //                       }}
// //                     >
// //                       <div className="text-[11px] text-neutral-400 mb-1.5 font-rethink">
// //                         {activeTab === "releases"
// //                           ? p.date
// //                           : `${p.source} • ${p.date}`}
// //                       </div>
// //                       <h4 className="text-[14px] font-medium leading-relaxed text-neutral-800 group-hover:text-[#8B0F1A] transition font-rethink">
// //                         {p.title}
// //                       </h4>
// //                     </div>
// //                   </div>
// //                 ))}
// //               </div>
// //             </div>
// //           </div>

// //           {/* ══════════════════════════════════════════════════
// //               MIDDLE – LEADERSHIP INSIGHTS
// //               ══════════════════════════════════════════════════ */}
// //           <div
// //             className="lg:w-[500px] bg-[#ffffff] rounded-3xl shadow-xl overflow-hidden flex flex-col h-full"
// //             onMouseEnter={() => setIsHovering(true)}
// //             onMouseLeave={() => setIsHovering(false)}
// //           >
// //             {/* Header */}
// //             <div className="p-6 border-b flex items-center justify-between">
// //               <div>
// //                 <h3 className="text-[18px] font-semibold text-[#da2128] font-rethink">
// //                   Leadership Insights
// //                 </h3>
// //                 <p className="text-[13px] text-gray-500">Voices of Impact</p>
// //               </div>
// //               <div className="flex gap-2">
// //                 {insights.map((_, idx) => (
// //                   <button
// //                     key={idx}
// //                     onClick={() => setCurrentIndex(idx)}
// //                     className={`w-2.5 h-2.5 rounded-full transition-all ${
// //                       idx === currentIndex
// //                         ? "bg-[#da2128] scale-125"
// //                         : "bg-gray-300"
// //                     }`}
// //                   />
// //                 ))}
// //               </div>
// //             </div>

// //             {/* Content */}
// //             <div className="flex-1 p-3 flex flex-col">
// //               {insightsLoading && (
// //                 <div className="flex-1 flex items-center justify-center text-sm text-gray-400">
// //                   Loading...
// //                 </div>
// //               )}

// //               {!insightsLoading && insights.length === 0 && (
// //                 <div className="flex-1 flex items-center justify-center text-sm text-gray-400">
// //                   No insights found
// //                 </div>
// //               )}

// //               {!insightsLoading && currentInsight && (
// //                 <div className="flex-1 flex flex-col lg:flex-row gap-8 items-start">
// //                   {/* Big Quote Mark */}
// //                   <div className="text-[90px] leading-none text-[#DA2128] font-serif flex-shrink-0 -mt-8">
// //                     &ldquo;
// //                   </div>

// //                   {/* Text + Image */}
// //                   <div className="flex-1">
// //                     {/* Circular Image */}
// //                     <div className="flex justify-center mb-6">
// //                       <div className="w-40 h-40 rounded-full overflow-hidden border-4 border-white shadow-2xl">
// //                         <img
// //                           src={currentInsight.image}
// //                           alt={currentInsight.name}
// //                           className="w-full h-full object-cover"
// //                         />
// //                       </div>
// //                     </div>

// //                     {/* Name & Designation */}
// //                     <div className="text-center mb-6">
// //                       <p className="text-xl font-semibold text-neutral-900">
// //                         {currentInsight.name}
// //                       </p>
// //                       <p className="text-[#8B0F1A] text-sm tracking-wider">
// //                         {currentInsight.designation}
// //                       </p>
// //                     </div>

// //                     {/* Quote Text */}
// //                     <p className="text-[15.5px] leading-relaxed text-neutral-700 text-left">
// //                       {currentInsight.text}
// //                     </p>

// //                     {currentInsight.link && (
// //                       <a
// //                         href={currentInsight.link}
// //                         target="_blank"
// //                         rel="noopener noreferrer"
// //                         className="inline-block text-[#da2128] font-medium text-sm cursor-pointer hover:underline"
// //                       >
// //                         ... Read More
// //                       </a>
// //                     )}
// //                   </div>
// //                 </div>
// //               )}
// //             </div>

// //             {/* Progress Bar */}
// //             <div className="h-1 bg-gray-100 mx-10 mb-6 rounded-full overflow-hidden">
// //               <div
// //                 className="h-full bg-[#da2128] rounded-full transition-all"
// //                 style={{
// //                   animation: isHovering
// //                     ? "none"
// //                     : "progress 8s linear infinite",
// //                 }}
// //               />
// //             </div>
// //           </div>

// //           {/* ══════════════════════════════════════════════════
// //               RIGHT – SOCIAL WALL
// //               ══════════════════════════════════════════════════ */}
// //           <div className="lg:w-[420px] bg-[#ffffff] backdrop-blur-lg border border-white/30 rounded-3xl shadow-sm p-4 flex flex-col h-full">
// //             {/* Header */}
// //             <div className="flex items-center justify-between mb-4">
// //               <h3 className="text-lg font-semibold text-[#da2128]">
// //                 Social Wall
// //               </h3>

// //               <div className="flex gap-2">
// //                 {[
// //                   {
// //                     id: "linkedin",
// //                     icon: <FaLinkedinIn />,
// //                     color: "bg-blue-700",
// //                   },
// //                   {
// //                     id: "twitter",
// //                     icon: <FaXTwitter />,
// //                     color: "bg-black",
// //                   },
// //                   {
// //                     id: "facebook",
// //                     icon: <FaFacebookF />,
// //                     color: "bg-blue-600",
// //                   },
// //                   {
// //                     id: "instagram",
// //                     icon: <FaInstagram />,
// //                     color: "bg-pink-500",
// //                   },
// //                 ].map((item) => (
// //                   <div
// //                     key={item.id}
// //                     onClick={() => setActiveSocial(item.id)}
// //                     className={`w-9 h-9 flex items-center justify-center rounded-xl cursor-pointer transition-all duration-300 ${
// //                       activeSocial === item.id
// //                         ? `${item.color} text-white shadow-lg`
// //                         : "bg-white text-gray-600 hover:bg-gray-100"
// //                     }`}
// //                   >
// //                     {item.icon}
// //                   </div>
// //                 ))}
// //               </div>
// //             </div>

// //             {/* Social Content */}
// //             <div className="flex-1 overflow-hidden rounded-2xl bg-white relative">
// //               {/* Facebook */}
// //               <div
// //                 className={
// //                   activeSocial === "facebook" ? "block h-full" : "hidden"
// //                 }
// //               >
// //                 <iframe
// //                   src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2FASSOCHAM4Ind%2Fposts%2Fpfbid0RszAkkxef8VK1DhUqeHvNYSW1ohm4ThBoPfPiWg1fRN1ZCGuU3RvATuJDAEm3ZGMl&show_text=true"
// //                   className="w-full h-full"
// //                   style={{ border: "none" }}
// //                   scrolling="no"
// //                   title="Facebook Post"
// //                 />
// //               </div>

// //               {/* Twitter / X */}
// //               <div
// //                 className={
// //                   activeSocial === "twitter" ? "block h-full" : "hidden"
// //                 }
// //               >
// //                 <div className="w-full h-full overflow-y-auto p-3">
// //                   <blockquote className="twitter-tweet">
// //                     <a href="https://twitter.com/ASSOCHAM4India/status/1410202976107450370">
// //                       Tweet
// //                     </a>
// //                   </blockquote>
// //                 </div>
// //               </div>

// //               {/* Instagram */}
// //               <div
// //                 className={
// //                   activeSocial === "instagram" ? "block h-full" : "hidden"
// //                 }
// //               >
// //                 <div className="w-full h-full overflow-y-auto p-3">
// //                   <blockquote
// //                     className="instagram-media"
// //                     data-instgrm-permalink="https://www.instagram.com/p/DXlOfzDkTMA/"
// //                     data-instgrm-version="14"
// //                   />
// //                 </div>
// //               </div>

// //               {/* LinkedIn */}
// //               <div
// //                 className={
// //                   activeSocial === "linkedin" ? "block h-full" : "hidden"
// //                 }
// //               >
// //                 <iframe
// //                   src="https://www.linkedin.com/embed/feed/update/urn:li:share:7467553270425636864?collapsed=1"
// //                   width="100%"
// //                   height="700"
// //                   style={{ border: 0 }}
// //                   title="LinkedIn Post"
// //                 />
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* ── Animations & Styles ────────────────────────────── */}
// //       <style jsx>{`
// //         .press-loop {
// //           animation: pressScroll 90s linear infinite;
// //           will-change: transform;
// //         }
// //         .press-loop.paused {
// //           animation-play-state: paused;
// //         }
// //         @keyframes pressScroll {
// //           0% {
// //             transform: translateY(0);
// //           }
// //           100% {
// //             transform: translateY(-50%);
// //           }
// //         }
// //         @keyframes progress {
// //           from {
// //             width: 0%;
// //           }
// //           to {
// //             width: 100%;
// //           }
// //         }
// //       `}</style>
// //     </section>
// //   );
// // }






// // new new code 





// import { useEffect, useState, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   FaFacebookF,
//   FaInstagram,
//   FaLinkedinIn,
//   FaChevronLeft,
//   FaChevronRight,
// } from "react-icons/fa";
// import { FaXTwitter } from "react-icons/fa6";
// import { fetchPressReleases } from "../News/pressReleaseApi.js";
// import { fetchPressCoverages } from "../News/pressCoverageApi.js";
// import { fetchLeadershipInsights } from "../api/leadershipInsightsApi.js";
// import { fetchInstagramFeed } from "../api/instagramApi.js";

// export default function MediaSocialSection() {
//   const [activeTab, setActiveTab] = useState("releases");
//   const [activeSocial, setActiveSocial] = useState("facebook");

//   const [insights, setInsights] = useState([]);
//   const [insightsLoading, setInsightsLoading] = useState(true);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isHovering, setIsHovering] = useState(false);

//   const [isPressHovering, setIsPressHovering] = useState(false);

//   const [pressReleases, setPressReleases] = useState([]);
//   const [pressCoverage, setPressCoverage] = useState([]);

//   // ── Instagram feed (one post at a time) ────────────────────
//   const [igFeed, setIgFeed] = useState([]);
//   const [igLoading, setIgLoading] = useState(false);
//   const [igError, setIgError] = useState(null);
//   const [igFetched, setIgFetched] = useState(false);
//   const [igIndex, setIgIndex] = useState(0);
//   const [igHover, setIgHover] = useState(false);

//   const navigate = useNavigate();

//   /* ── Press releases + coverage ─────────────────────────── */
//   useEffect(() => {
//     let alive = true;

//     fetchPressReleases()
//       .then((data) => {
//         if (!alive) return;
//         setPressReleases(
//           data.slice(0, 20).map((pr) => ({
//             title: pr.title,
//             date: pr.displayDate,
//             slug: pr.slug,
//           }))
//         );
//       })
//       .catch((err) => console.error("Press releases fetch failed:", err));

//     fetchPressCoverages()
//       .then((data) => {
//         if (!alive) return;
//         setPressCoverage(
//           data.slice(0, 20).map((pc) => ({
//             title: pc.title,
//             date: pc.displayDate,
//             source: pc.source || "",
//             externalUrl: pc.externalUrl || "",
//           }))
//         );
//       })
//       .catch((err) => console.error("Press coverage fetch failed:", err));

//     return () => {
//       alive = false;
//     };
//   }, []);

//   /* ── Leadership Insights ───────────────────────────────── */
//   useEffect(() => {
//     let alive = true;
//     fetchLeadershipInsights()
//       .then((data) => alive && setInsights(data))
//       .catch((err) => console.error("Leadership insights fetch failed:", err))
//       .finally(() => alive && setInsightsLoading(false));
//     return () => {
//       alive = false;
//     };
//   }, []);

//   /* ── Instagram feed – lazy fetch on first tab open ─────── */
//   useEffect(() => {
//     if (activeSocial !== "instagram" || igFetched) return;
//     let alive = true;

//     setIgLoading(true);
//     // Fetch a large batch; backend will paginate through all posts.
//     fetchInstagramFeed(100)
//       .then((data) => {
//         if (!alive) return;
//         // Ensure latest first (sort by timestamp desc)
//         const sorted = [...data].sort(
//           (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
//         );
//         setIgFeed(sorted);
//         setIgIndex(0);
//         setIgError(null);
//       })
//       .catch((err) => {
//         if (!alive) return;
//         console.error("Instagram feed fetch failed:", err);
//         setIgError("Couldn't load Instagram feed.");
//       })
//       .finally(() => {
//         if (!alive) return;
//         setIgLoading(false);
//         setIgFetched(true);
//       });

//     return () => {
//       alive = false;
//     };
//   }, [activeSocial, igFetched]);

//   /* ── Instagram auto-rotate ─────────────────────────────── */
//   useEffect(() => {
//     if (activeSocial !== "instagram" || igFeed.length <= 1) return;
//     const id = setInterval(() => {
//       if (!igHover) {
//         setIgIndex((p) => (p + 1) % igFeed.length);
//       }
//     }, 6000);
//     return () => clearInterval(id);
//   }, [activeSocial, igFeed.length, igHover]);

//   const igPrev = useCallback(() => {
//     setIgIndex((p) => (p - 1 + igFeed.length) % igFeed.length);
//   }, [igFeed.length]);

//   const igNext = useCallback(() => {
//     setIgIndex((p) => (p + 1) % igFeed.length);
//   }, [igFeed.length]);

//   const currentList =
//     activeTab === "releases" ? pressReleases : pressCoverage;
//   const loopedList = [
//     ...currentList,
//     ...currentList,
//     ...currentList,
//     ...currentList,
//   ];
//   const currentInsight = insights[currentIndex];

//   const handleItemClick = (item) => {
//     if (activeTab === "releases") {
//       if (item.slug) navigate(`/press-release/${item.slug}`);
//     } else if (item.externalUrl) {
//       window.open(item.externalUrl, "_blank", "noopener,noreferrer");
//     }
//   };

//   /* ── Leadership auto rotate ────────────────────────────── */
//   useEffect(() => {
//     if (insights.length === 0) return;
//     const interval = setInterval(() => {
//       if (!isHovering) {
//         setCurrentIndex((prev) => (prev + 1) % insights.length);
//       }
//     }, 8000);
//     return () => clearInterval(interval);
//   }, [isHovering, insights.length]);

//   /* ── Social embeds ─────────────────────────────────────── */
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (window.twttr) window.twttr.widgets.load();
//       if (window.instgrm) window.instgrm.Embeds.process();
//     }, 800);
//     return () => clearTimeout(timer);
//   }, []);

//   const currentIgPost = igFeed[igIndex];

//   return (
//     <section className="py-10 bg-[#FAF7F2]">
//       <div className="mb-6 text-center">
//         <h2 className="mt-2 text-[22px] font-semibold leading-tight font-rethink">
//           Public Voice{" "}
//           <span className="italic text-[#da2128]">Digital Presence</span>
//         </h2>
//       </div>

//       <div className="mx-auto px-6">
//         <div className="flex flex-col lg:flex-row gap-8 h-[520px]">
//           {/* ══════════ LEFT – PRESS ══════════ */}
//           <div
//             className="lg:w-[490px] bg-[#ffffff] backdrop-blur-lg rounded-3xl p-8 shadow-sm flex flex-col h-full"
//             onMouseEnter={() => setIsPressHovering(true)}
//             onMouseLeave={() => setIsPressHovering(false)}
//           >
//             <div className="flex gap-4 mb-8 border-b pb-1">
//               <button
//                 onClick={() => setActiveTab("releases")}
//                 className={`pb-3 text-[14px] font-medium transition-all font-rethink ${
//                   activeTab === "releases"
//                     ? "text-[#da2128] border-b-2 border-[#8B0F1A]"
//                     : "text-gray-500 hover:text-[#8B0F1A]"
//                 }`}
//               >
//                 Press Releases
//               </button>
//               <button
//                 onClick={() => setActiveTab("coverage")}
//                 className={`pb-3 text-[14px] font-medium transition-all font-rethink ${
//                   activeTab === "coverage"
//                     ? "text-[#da2128] border-b-2 border-[#8B0F1A]"
//                     : "text-gray-500 hover:text-[#8B0F1A]"
//                 }`}
//               >
//                 Press Coverage
//               </button>
//             </div>

//             <div className="relative flex-1 overflow-hidden">
//               <div className="absolute left-6 top-0 bottom-0 w-[2px] bg-[#8B0F1A]/20"></div>
//               <div
//                 className={`press-loop space-y-8 pr-4 overflow-hidden ${
//                   isPressHovering ? "paused" : ""
//                 }`}
//               >
//                 {loopedList.map((p, i) => (
//                   <div key={`${activeTab}-${i}`} className="relative pl-10">
//                     <span className="absolute left-6 top-2 -translate-x-1/2 w-3 h-3 bg-[#8B0F1A] rounded-full border-2 border-white"></span>
//                     <div
//                       className="group cursor-pointer"
//                       onClick={() => handleItemClick(p)}
//                       role="button"
//                       tabIndex={0}
//                       onKeyDown={(e) => {
//                         if (e.key === "Enter" || e.key === " ") {
//                           handleItemClick(p);
//                         }
//                       }}
//                     >
//                       <div className="text-[11px] text-neutral-400 mb-1.5 font-rethink">
//                         {activeTab === "releases"
//                           ? p.date
//                           : `${p.source} • ${p.date}`}
//                       </div>
//                       <h4 className="text-[14px] font-medium leading-relaxed text-neutral-800 group-hover:text-[#8B0F1A] transition font-rethink">
//                         {p.title}
//                       </h4>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>

//           {/* ══════════ MIDDLE – LEADERSHIP ══════════ */}
//           <div
//             className="lg:w-[500px] bg-[#ffffff] rounded-3xl shadow-xl overflow-hidden flex flex-col h-full"
//             onMouseEnter={() => setIsHovering(true)}
//             onMouseLeave={() => setIsHovering(false)}
//           >
//             <div className="p-6 border-b flex items-center justify-between">
//               <div>
//                 <h3 className="text-[18px] font-semibold text-[#da2128] font-rethink">
//                   Leadership Insights
//                 </h3>
//                 <p className="text-[13px] text-gray-500">Voices of Impact</p>
//               </div>
//               <div className="flex gap-2">
//                 {insights.map((_, idx) => (
//                   <button
//                     key={idx}
//                     onClick={() => setCurrentIndex(idx)}
//                     className={`w-2.5 h-2.5 rounded-full transition-all ${
//                       idx === currentIndex
//                         ? "bg-[#da2128] scale-125"
//                         : "bg-gray-300"
//                     }`}
//                   />
//                 ))}
//               </div>
//             </div>

//             <div className="flex-1 p-3 flex flex-col">
//               {insightsLoading && (
//                 <div className="flex-1 flex items-center justify-center text-sm text-gray-400">
//                   Loading...
//                 </div>
//               )}
//               {!insightsLoading && insights.length === 0 && (
//                 <div className="flex-1 flex items-center justify-center text-sm text-gray-400">
//                   No insights found
//                 </div>
//               )}
//               {!insightsLoading && currentInsight && (
//                 <div className="flex-1 flex flex-col lg:flex-row gap-8 items-start">
//                   <div className="text-[90px] leading-none text-[#DA2128] font-serif flex-shrink-0 -mt-8">
//                     &ldquo;
//                   </div>
//                   <div className="flex-1">
//                     <div className="flex justify-center mb-6">
//                       <div className="w-40 h-40 rounded-full overflow-hidden border-4 border-white shadow-2xl">
//                         <img
//                           src={currentInsight.image}
//                           alt={currentInsight.name}
//                           className="w-full h-full object-cover"
//                         />
//                       </div>
//                     </div>
//                     <div className="text-center mb-6">
//                       <p className="text-xl font-semibold text-neutral-900">
//                         {currentInsight.name}
//                       </p>
//                       <p className="text-[#8B0F1A] text-sm tracking-wider">
//                         {currentInsight.designation}
//                       </p>
//                     </div>
//                     <p className="text-[15.5px] leading-relaxed text-neutral-700 text-left">
//                       {currentInsight.text}
//                     </p>
//                     {currentInsight.link && (
//                       <a
//                         href={currentInsight.link}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="inline-block text-[#da2128] font-medium text-sm cursor-pointer hover:underline"
//                       >
//                         ... Read More
//                       </a>
//                     )}
//                   </div>
//                 </div>
//               )}
//             </div>

//             <div className="h-1 bg-gray-100 mx-10 mb-6 rounded-full overflow-hidden">
//               <div
//                 className="h-full bg-[#da2128] rounded-full transition-all"
//                 style={{
//                   animation: isHovering
//                     ? "none"
//                     : "progress 8s linear infinite",
//                 }}
//               />
//             </div>
//           </div>

//           {/* ══════════ RIGHT – SOCIAL WALL ══════════ */}
//           <div className="lg:w-[420px] bg-[#ffffff] backdrop-blur-lg border border-white/30 rounded-3xl shadow-sm p-4 flex flex-col h-full">
//             <div className="flex items-center justify-between mb-4">
//               <h3 className="text-lg font-semibold text-[#da2128]">
//                 Social Wall
//               </h3>

//               <div className="flex gap-2">
//                 {[
//                   { id: "linkedin", icon: <FaLinkedinIn />, color: "bg-blue-700" },
//                   { id: "twitter", icon: <FaXTwitter />, color: "bg-black" },
//                   { id: "facebook", icon: <FaFacebookF />, color: "bg-blue-600" },
//                   { id: "instagram", icon: <FaInstagram />, color: "bg-pink-500" },
//                 ].map((item) => (
//                   <div
//                     key={item.id}
//                     onClick={() => setActiveSocial(item.id)}
//                     className={`w-9 h-9 flex items-center justify-center rounded-xl cursor-pointer transition-all duration-300 ${
//                       activeSocial === item.id
//                         ? `${item.color} text-white shadow-lg`
//                         : "bg-white text-gray-600 hover:bg-gray-100"
//                     }`}
//                   >
//                     {item.icon}
//                   </div>
//                 ))}
//               </div>
//             </div>

//             <div className="flex-1 overflow-hidden rounded-2xl bg-white relative">
//               {/* Facebook */}
//               <div className={activeSocial === "facebook" ? "block h-full" : "hidden"}>
//                 <iframe
//                   src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2FASSOCHAM4Ind%2Fposts%2Fpfbid0RszAkkxef8VK1DhUqeHvNYSW1ohm4ThBoPfPiWg1fRN1ZCGuU3RvATuJDAEm3ZGMl&show_text=true"
//                   className="w-full h-full"
//                   style={{ border: "none" }}
//                   scrolling="no"
//                   title="Facebook Post"
//                 />
//               </div>

//               {/* Twitter */}
//               <div className={activeSocial === "twitter" ? "block h-full" : "hidden"}>
//                 <div className="w-full h-full overflow-y-auto p-3">
//                   <blockquote className="twitter-tweet">
//                     <a href="https://twitter.com/ASSOCHAM4India/status/1410202976107450370">
//                       Tweet
//                     </a>
//                   </blockquote>
//                 </div>
//               </div>

//               {/* ───────── INSTAGRAM – ONE POST AT A TIME ───────── */}
//               <div className={activeSocial === "instagram" ? "block h-full" : "hidden"}>
//                 <div
//                   className="w-full h-full flex flex-col"
//                   onMouseEnter={() => setIgHover(true)}
//                   onMouseLeave={() => setIgHover(false)}
//                 >
//                   {igLoading && igFeed.length === 0 && (
//                     <div className="flex-1 flex items-center justify-center text-sm text-gray-400">
//                       Loading Instagram feed...
//                     </div>
//                   )}

//                   {!igLoading && igError && (
//                     <div className="flex-1 flex items-center justify-center text-sm text-gray-400 text-center px-4">
//                       {igError}
//                     </div>
//                   )}

//                   {!igLoading && !igError && igFeed.length === 0 && (
//                     <div className="flex-1 flex items-center justify-center text-sm text-gray-400">
//                       No posts found
//                     </div>
//                   )}

//                   {currentIgPost && (
//                     <>
//                       {/* ── Single Post Card ── */}
//                       <div className="flex-1 relative overflow-hidden rounded-xl bg-neutral-50">
//                         <a
//                           href={currentIgPost.permalink}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className="group block w-full h-full"
//                         >
//                           {/* Media */}
//                           <div className="relative w-full h-full">
//                             <img
//                               key={currentIgPost.id}
//                               src={currentIgPost.image}
//                               alt={
//                                 currentIgPost.caption
//                                   ? currentIgPost.caption.slice(0, 80)
//                                   : "Instagram post"
//                               }
//                               className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
//                               loading="lazy"
//                             />

//                             {/* Video badge */}
//                             {currentIgPost.media_type === "VIDEO" && (
//                               <span className="absolute top-3 right-3 bg-black/70 text-white text-[10px] font-medium px-2 py-1 rounded-full flex items-center gap-1">
//                                 <FaInstagram size={10} /> Reel
//                               </span>
//                             )}

//                             {/* Gradient overlay + caption */}
//                             <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/85 via-black/50 to-transparent p-4 pt-10">
//                               <p className="text-white text-[12.5px] leading-relaxed line-clamp-4">
//                                 {currentIgPost.caption
//                                   ? currentIgPost.caption.slice(0, 180) +
//                                     (currentIgPost.caption.length > 180
//                                       ? "..."
//                                       : "")
//                                   : "View post on Instagram"}
//                               </p>
//                               <p className="text-white/70 text-[10.5px] mt-1.5">
//                                 {currentIgPost.timestamp
//                                   ? new Date(
//                                       currentIgPost.timestamp
//                                     ).toLocaleDateString("en-IN", {
//                                       day: "numeric",
//                                       month: "short",
//                                       year: "numeric",
//                                     })
//                                   : ""}
//                               </p>
//                             </div>
//                           </div>
//                         </a>

//                         {/* ── Prev / Next arrows ── */}
//                         {igFeed.length > 1 && (
//                           <>
//                             <button
//                               onClick={igPrev}
//                               aria-label="Previous post"
//                               className="absolute left-2 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center rounded-full bg-white/90 hover:bg-white text-[#8B0F1A] shadow-md transition"
//                             >
//                               <FaChevronLeft size={12} />
//                             </button>
//                             <button
//                               onClick={igNext}
//                               aria-label="Next post"
//                               className="absolute right-2 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center rounded-full bg-white/90 hover:bg-white text-[#8B0F1A] shadow-md transition"
//                             >
//                               <FaChevronRight size={12} />
//                             </button>
//                           </>
//                         )}
//                       </div>

//                       {/* ── Dots indicator ── */}
//                       {igFeed.length > 1 && (
//                         <div className="flex justify-center gap-1.5 mt-3 max-w-full overflow-hidden">
//                           {igFeed.slice(0, 12).map((_, idx) => (
//                             <button
//                               key={idx}
//                               onClick={() => setIgIndex(idx)}
//                               aria-label={`Go to post ${idx + 1}`}
//                               className={`h-1.5 rounded-full transition-all ${
//                                 idx === igIndex
//                                   ? "w-5 bg-[#da2128]"
//                                   : "w-1.5 bg-gray-300 hover:bg-gray-400"
//                               }`}
//                             />
//                           ))}
//                           {igFeed.length > 12 && (
//                             <span className="text-[10px] text-gray-400 ml-1">
//                               +{igFeed.length - 12}
//                             </span>
//                           )}
//                         </div>
//                       )}

//                       {/* ── Counter ── */}
//                       <p className="text-center text-[11px] text-gray-400 mt-2">
//                         {igIndex + 1} / {igFeed.length}
//                       </p>
//                     </>
//                   )}
//                 </div>
//               </div>

//               {/* LinkedIn */}
//               <div className={activeSocial === "linkedin" ? "block h-full" : "hidden"}>
//                 <iframe
//                   src="https://www.linkedin.com/embed/feed/update/urn:li:share:7467553270425636864?collapsed=1"
//                   width="100%"
//                   height="700"
//                   style={{ border: 0 }}
//                   title="LinkedIn Post"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <style jsx>{`
//         .press-loop {
//           animation: pressScroll 90s linear infinite;
//           will-change: transform;
//         }
//         .press-loop.paused {
//           animation-play-state: paused;
//         }
//         @keyframes pressScroll {
//           0% { transform: translateY(0); }
//           100% { transform: translateY(-50%); }
//         }
//         @keyframes progress {
//           from { width: 0%; }
//           to { width: 100%; }
//         }
//         .line-clamp-4 {
//           display: -webkit-box;
//           -webkit-line-clamp: 4;
//           -webkit-box-orient: vertical;
//           overflow: hidden;
//         }
//       `}</style>
//     </section>
//   );
// }





// new new code 




import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { fetchPressReleases } from "../News/pressReleaseApi.js";
import { fetchPressCoverages } from "../News/pressCoverageApi.js";
import { fetchLeadershipInsights } from "../api/leadershipInsightsApi.js";
import { fetchInstagramFeed } from "../api/instagramApi.js";
import { fetchLinkedInFeed } from "../api/linkedinFeedApi.js"; // 👈 naya

export default function MediaSocialSection() {
  const [activeTab, setActiveTab] = useState("releases");
  const [activeSocial, setActiveSocial] = useState("facebook");

  const [insights, setInsights] = useState([]);
  const [insightsLoading, setInsightsLoading] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovering, setIsHovering] = useState(false);
  const [isPressHovering, setIsPressHovering] = useState(false);

  const [pressReleases, setPressReleases] = useState([]);
  const [pressCoverage, setPressCoverage] = useState([]);

  // ── Instagram feed ──
  const [igFeed, setIgFeed] = useState([]);
  const [igLoading, setIgLoading] = useState(false);
  const [igError, setIgError] = useState(null);
  const [igFetched, setIgFetched] = useState(false);
  const [igIndex, setIgIndex] = useState(0);
  const [igHover, setIgHover] = useState(false);

  // ── LinkedIn feed (naya) ──
  const [liFeed, setLiFeed] = useState([]);
  const [liLoading, setLiLoading] = useState(false);
  const [liError, setLiError] = useState(null);
  const [liFetched, setLiFetched] = useState(false);
  const [liIndex, setLiIndex] = useState(0);
  const [liHover, setLiHover] = useState(false);

  const navigate = useNavigate();

  /* ── Press releases + coverage ── */
  useEffect(() => {
    let alive = true;
    fetchPressReleases()
      .then((data) => {
        if (!alive) return;
        setPressReleases(
          data.slice(0, 20).map((pr) => ({
            title: pr.title,
            date: pr.displayDate,
            slug: pr.slug,
          }))
        );
      })
      .catch((err) => console.error("Press releases fetch failed:", err));

    fetchPressCoverages()
      .then((data) => {
        if (!alive) return;
        setPressCoverage(
          data.slice(0, 20).map((pc) => ({
            title: pc.title,
            date: pc.displayDate,
            source: pc.source || "",
            externalUrl: pc.externalUrl || "",
          }))
        );
      })
      .catch((err) => console.error("Press coverage fetch failed:", err));

    return () => { alive = false; };
  }, []);

  /* ── Leadership Insights ── */
  useEffect(() => {
    let alive = true;
    fetchLeadershipInsights()
      .then((data) => alive && setInsights(data))
      .catch((err) => console.error("Leadership insights fetch failed:", err))
      .finally(() => alive && setInsightsLoading(false));
    return () => { alive = false; };
  }, []);

  /* ── Instagram lazy fetch ── */
  useEffect(() => {
    if (activeSocial !== "instagram" || igFetched) return;
    let alive = true;
    setIgLoading(true);
    fetchInstagramFeed(100)
      .then((data) => {
        if (!alive) return;
        const sorted = [...data].sort(
          (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
        );
        setIgFeed(sorted);
        setIgIndex(0);
        setIgError(null);
      })
      .catch((err) => {
        if (!alive) return;
        console.error("Instagram feed fetch failed:", err);
        setIgError("Couldn't load Instagram feed.");
      })
      .finally(() => {
        if (!alive) return;
        setIgLoading(false);
        setIgFetched(true);
      });
    return () => { alive = false; };
  }, [activeSocial, igFetched]);

  /* ── LinkedIn lazy fetch (naya) ── */
  useEffect(() => {
    if (activeSocial !== "linkedin" || liFetched) return;
    let alive = true;
    setLiLoading(true);
    fetchLinkedInFeed(100)
      .then((data) => {
        if (!alive) return;
        const sorted = [...data].sort(
          (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
        );
        setLiFeed(sorted);
        setLiIndex(0);
        setLiError(null);
      })
      .catch((err) => {
        if (!alive) return;
        console.error("LinkedIn feed fetch failed:", err);
        setLiError("Couldn't load LinkedIn feed.");
      })
      .finally(() => {
        if (!alive) return;
        setLiLoading(false);
        setLiFetched(true);
      });
    return () => { alive = false; };
  }, [activeSocial, liFetched]);

  /* ── Instagram auto-rotate ── */
  useEffect(() => {
    if (activeSocial !== "instagram" || igFeed.length <= 1) return;
    const id = setInterval(() => {
      if (!igHover) setIgIndex((p) => (p + 1) % igFeed.length);
    }, 6000);
    return () => clearInterval(id);
  }, [activeSocial, igFeed.length, igHover]);

  /* ── LinkedIn auto-rotate (naya) ── */
  useEffect(() => {
    if (activeSocial !== "linkedin" || liFeed.length <= 1) return;
    const id = setInterval(() => {
      if (!liHover) setLiIndex((p) => (p + 1) % liFeed.length);
    }, 6000);
    return () => clearInterval(id);
  }, [activeSocial, liFeed.length, liHover]);

  const igPrev = useCallback(() => {
    setIgIndex((p) => (p - 1 + igFeed.length) % igFeed.length);
  }, [igFeed.length]);
  const igNext = useCallback(() => {
    setIgIndex((p) => (p + 1) % igFeed.length);
  }, [igFeed.length]);

  const liPrev = useCallback(() => {
    setLiIndex((p) => (p - 1 + liFeed.length) % liFeed.length);
  }, [liFeed.length]);
  const liNext = useCallback(() => {
    setLiIndex((p) => (p + 1) % liFeed.length);
  }, [liFeed.length]);

  const currentList = activeTab === "releases" ? pressReleases : pressCoverage;
  const loopedList = [...currentList, ...currentList, ...currentList, ...currentList];
  const currentInsight = insights[currentIndex];

  const handleItemClick = (item) => {
    if (activeTab === "releases") {
      if (item.slug) navigate(`/press-release/${item.slug}`);
    } else if (item.externalUrl) {
      window.open(item.externalUrl, "_blank", "noopener,noreferrer");
    }
  };

  /* ── Leadership auto rotate ── */
  useEffect(() => {
    if (insights.length === 0) return;
    const interval = setInterval(() => {
      if (!isHovering) {
        setCurrentIndex((prev) => (prev + 1) % insights.length);
      }
    }, 8000);
    return () => clearInterval(interval);
  }, [isHovering, insights.length]);

  /* ── Social embeds (Twitter + Instagram script loaders) ── */
  useEffect(() => {
    const timer = setTimeout(() => {
      if (window.twttr) window.twttr.widgets.load();
      if (window.instgrm) window.instgrm.Embeds.process();
    }, 800);
    return () => clearTimeout(timer);
  }, []);

  const currentIgPost = igFeed[igIndex];
  const currentLiPost = liFeed[liIndex];

  return (
    <section className="py-10 bg-[#FAF7F2]">
      <div className="mb-6 text-center">
        <h2 className="mt-2 text-[22px] font-semibold leading-tight font-rethink">
          Public Voice <span className="italic text-[#da2128]">Digital Presence</span>
        </h2>
      </div>

      <div className="mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-8 h-[520px]">
          {/* ══════════ LEFT – PRESS ══════════ */}
          <div
            className="lg:w-[490px] bg-white backdrop-blur-lg rounded-3xl p-8 shadow-sm flex flex-col h-full"
            onMouseEnter={() => setIsPressHovering(true)}
            onMouseLeave={() => setIsPressHovering(false)}
          >
            <div className="flex gap-4 mb-8 border-b pb-1">
              <button
                onClick={() => setActiveTab("releases")}
                className={`pb-3 text-[14px] font-medium transition-all font-rethink ${
                  activeTab === "releases"
                    ? "text-[#da2128] border-b-2 border-[#8B0F1A]"
                    : "text-gray-500 hover:text-[#8B0F1A]"
                }`}
              >
                Press Releases
              </button>
              <button
                onClick={() => setActiveTab("coverage")}
                className={`pb-3 text-[14px] font-medium transition-all font-rethink ${
                  activeTab === "coverage"
                    ? "text-[#da2128] border-b-2 border-[#8B0F1A]"
                    : "text-gray-500 hover:text-[#8B0F1A]"
                }`}
              >
                Press Coverage
              </button>
            </div>

            <div className="relative flex-1 overflow-hidden">
              <div className="absolute left-6 top-0 bottom-0 w-[2px] bg-[#8B0F1A]/20"></div>
              <div className={`press-loop space-y-8 pr-4 overflow-hidden ${isPressHovering ? "paused" : ""}`}>
                {loopedList.map((p, i) => (
                  <div key={`${activeTab}-${i}`} className="relative pl-10">
                    <span className="absolute left-6 top-2 -translate-x-1/2 w-3 h-3 bg-[#8B0F1A] rounded-full border-2 border-white"></span>
                    <div
                      className="group cursor-pointer"
                      onClick={() => handleItemClick(p)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") handleItemClick(p);
                      }}
                    >
                      <div className="text-[11px] text-neutral-400 mb-1.5 font-rethink">
                        {activeTab === "releases" ? p.date : `${p.source} • ${p.date}`}
                      </div>
                      <h4 className="text-[14px] font-medium leading-relaxed text-neutral-800 group-hover:text-[#8B0F1A] transition font-rethink">
                        {p.title}
                      </h4>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* ══════════ MIDDLE – LEADERSHIP ══════════ */}
          <div
            className="lg:w-[500px] bg-white rounded-3xl shadow-xl overflow-hidden flex flex-col h-full"
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
          >
            <div className="p-6 border-b flex items-center justify-between">
              <div>
                <h3 className="text-[18px] font-semibold text-[#da2128] font-rethink">
                  Leadership Insights
                </h3>
                <p className="text-[13px] text-gray-500">Voices of Impact</p>
              </div>
              <div className="flex gap-2">
                {insights.map((_, idx) => (
                  <button
                    key={idx}
                    onClick={() => setCurrentIndex(idx)}
                    className={`w-2.5 h-2.5 rounded-full transition-all ${
                      idx === currentIndex ? "bg-[#da2128] scale-125" : "bg-gray-300"
                    }`}
                  />
                ))}
              </div>
            </div>

            <div className="flex-1 p-3 flex flex-col">
              {insightsLoading && (
                <div className="flex-1 flex items-center justify-center text-sm text-gray-400">
                  Loading...
                </div>
              )}
              {!insightsLoading && insights.length === 0 && (
                <div className="flex-1 flex items-center justify-center text-sm text-gray-400">
                  No insights found
                </div>
              )}
              {!insightsLoading && currentInsight && (
                <div className="flex-1 flex flex-col lg:flex-row gap-8 items-start">
                  <div className="text-[90px] leading-none text-[#DA2128] font-serif flex-shrink-0 -mt-8">
                    &ldquo;
                  </div>
                  <div className="flex-1">
                    <div className="flex justify-center mb-6">
                      <div className="w-40 h-40 rounded-full overflow-hidden border-4 border-white shadow-2xl">
                        <img
                          src={currentInsight.image}
                          alt={currentInsight.name}
                          className="w-full h-full object-cover"
                        />
                      </div>
                    </div>
                    <div className="text-center mb-6">
                      <p className="text-xl font-semibold text-neutral-900">
                        {currentInsight.name}
                      </p>
                      <p className="text-[#8B0F1A] text-sm tracking-wider">
                        {currentInsight.designation}
                      </p>
                    </div>
                    <p className="text-[15.5px] leading-relaxed text-neutral-700 text-left">
                      {currentInsight.text}
                    </p>
                    {currentInsight.link && (
                      <a
                        href={currentInsight.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block text-[#da2128] font-medium text-sm cursor-pointer hover:underline"
                      >
                        ... Read More
                      </a>
                    )}
                  </div>
                </div>
              )}
            </div>

            <div className="h-1 bg-gray-100 mx-10 mb-6 rounded-full overflow-hidden">
              <div
                className="h-full bg-[#da2128] rounded-full transition-all"
                style={{ animation: isHovering ? "none" : "progress 8s linear infinite" }}
              />
            </div>
          </div>

          {/* ══════════ RIGHT – SOCIAL WALL ══════════ */}
          <div className="lg:w-[420px] bg-white backdrop-blur-lg border border-white/30 rounded-3xl shadow-sm p-4 flex flex-col h-full">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-[#da2128]">Social Wall</h3>

              <div className="flex gap-2">
                {[
                  { id: "linkedin", icon: <FaLinkedinIn />, color: "bg-blue-700" },
                  { id: "twitter", icon: <FaXTwitter />, color: "bg-black" },
                  { id: "facebook", icon: <FaFacebookF />, color: "bg-blue-600" },
                  { id: "instagram", icon: <FaInstagram />, color: "bg-pink-500" },
                ].map((item) => (
                  <div
                    key={item.id}
                    onClick={() => setActiveSocial(item.id)}
                    className={`w-9 h-9 flex items-center justify-center rounded-xl cursor-pointer transition-all duration-300 ${
                      activeSocial === item.id
                        ? `${item.color} text-white shadow-lg`
                        : "bg-white text-gray-600 hover:bg-gray-100"
                    }`}
                  >
                    {item.icon}
                  </div>
                ))}
              </div>
            </div>

            <div className="flex-1 overflow-hidden rounded-2xl bg-white relative">
              {/* Facebook */}
              <div className={activeSocial === "facebook" ? "block h-full" : "hidden"}>
                <iframe
                  src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2FASSOCHAM4Ind%2Fposts%2Fpfbid0RszAkkxef8VK1DhUqeHvNYSW1ohm4ThBoPfPiWg1fRN1ZCGuU3RvATuJDAEm3ZGMl&show_text=true"
                  className="w-full h-full"
                  style={{ border: "none" }}
                  scrolling="no"
                  title="Facebook Post"
                />
              </div>

              {/* Twitter */}
              <div className={activeSocial === "twitter" ? "block h-full" : "hidden"}>
                <div className="w-full h-full overflow-y-auto p-3">
                  <blockquote className="twitter-tweet">
                    <a href="https://twitter.com/ASSOCHAM4India/status/1410202976107450370">
                      Tweet
                    </a>
                  </blockquote>
                </div>
              </div>

              {/* Instagram */}
              <div className={activeSocial === "instagram" ? "block h-full" : "hidden"}>
                <div
                  className="w-full h-full flex flex-col"
                  onMouseEnter={() => setIgHover(true)}
                  onMouseLeave={() => setIgHover(false)}
                >
                  {igLoading && igFeed.length === 0 && (
                    <div className="flex-1 flex items-center justify-center text-sm text-gray-400">
                      Loading Instagram feed...
                    </div>
                  )}
                  {!igLoading && igError && (
                    <div className="flex-1 flex items-center justify-center text-sm text-gray-400 text-center px-4">
                      {igError}
                    </div>
                  )}
                  {!igLoading && !igError && igFeed.length === 0 && (
                    <div className="flex-1 flex items-center justify-center text-sm text-gray-400">
                      No posts found
                    </div>
                  )}
                  {currentIgPost && (
                    <>
                      <div className="flex-1 relative overflow-hidden rounded-xl bg-neutral-50">
                        <a
                          href={currentIgPost.permalink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="group block w-full h-full"
                        >
                          <div className="relative w-full h-full">
                            <img
                              key={currentIgPost.id}
                              src={currentIgPost.image}
                              alt={
                                currentIgPost.caption
                                  ? currentIgPost.caption.slice(0, 80)
                                  : "Instagram post"
                              }
                              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                              loading="lazy"
                            />
                            {currentIgPost.media_type === "VIDEO" && (
                              <span className="absolute top-3 right-3 bg-black/70 text-white text-[10px] font-medium px-2 py-1 rounded-full flex items-center gap-1">
                                <FaInstagram size={10} /> Reel
                              </span>
                            )}
                            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/85 via-black/50 to-transparent p-4 pt-10">
                              <p className="text-white text-[12.5px] leading-relaxed line-clamp-4">
                                {currentIgPost.caption
                                  ? currentIgPost.caption.slice(0, 180) +
                                    (currentIgPost.caption.length > 180 ? "..." : "")
                                  : "View post on Instagram"}
                              </p>
                              <p className="text-white/70 text-[10.5px] mt-1.5">
                                {currentIgPost.timestamp
                                  ? new Date(currentIgPost.timestamp).toLocaleDateString("en-IN", {
                                      day: "numeric",
                                      month: "short",
                                      year: "numeric",
                                    })
                                  : ""}
                              </p>
                            </div>
                          </div>
                        </a>
                        {igFeed.length > 1 && (
                          <>
                            <button
                              onClick={igPrev}
                              aria-label="Previous post"
                              className="absolute left-2 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center rounded-full bg-white/90 hover:bg-white text-[#8B0F1A] shadow-md transition"
                            >
                              <FaChevronLeft size={12} />
                            </button>
                            <button
                              onClick={igNext}
                              aria-label="Next post"
                              className="absolute right-2 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center rounded-full bg-white/90 hover:bg-white text-[#8B0F1A] shadow-md transition"
                            >
                              <FaChevronRight size={12} />
                            </button>
                          </>
                        )}
                      </div>
                      {igFeed.length > 1 && (
                        <div className="flex justify-center gap-1.5 mt-3 max-w-full overflow-hidden">
                          {igFeed.slice(0, 12).map((_, idx) => (
                            <button
                              key={idx}
                              onClick={() => setIgIndex(idx)}
                              aria-label={`Go to post ${idx + 1}`}
                              className={`h-1.5 rounded-full transition-all ${
                                idx === igIndex
                                  ? "w-5 bg-[#da2128]"
                                  : "w-1.5 bg-gray-300 hover:bg-gray-400"
                              }`}
                            />
                          ))}
                          {igFeed.length > 12 && (
                            <span className="text-[10px] text-gray-400 ml-1">
                              +{igFeed.length - 12}
                            </span>
                          )}
                        </div>
                      )}
                      <p className="text-center text-[11px] text-gray-400 mt-2">
                        {igIndex + 1} / {igFeed.length}
                      </p>
                    </>
                  )}
                </div>
              </div>

              {/* ══════════ LINKEDIN – 1 BY 1 CAROUSEL ══════════ */}
              <div className={activeSocial === "linkedin" ? "block h-full" : "hidden"}>
                <div
                  className="w-full h-full flex flex-col"
                  onMouseEnter={() => setLiHover(true)}
                  onMouseLeave={() => setLiHover(false)}
                >
                  {liLoading && liFeed.length === 0 && (
                    <div className="flex-1 flex items-center justify-center text-sm text-gray-400">
                      Loading LinkedIn feed...
                    </div>
                  )}
                  {!liLoading && liError && (
                    <div className="flex-1 flex items-center justify-center text-sm text-gray-400 text-center px-4">
                      {liError}
                    </div>
                  )}
                  {!liLoading && !liError && liFeed.length === 0 && (
                    <div className="flex-1 flex items-center justify-center text-sm text-gray-400">
                      No posts found
                    </div>
                  )}

                  {currentLiPost && (
                    <>
                      <div className="flex-1 relative overflow-hidden rounded-xl bg-neutral-50">
                        <a
                          href={currentLiPost.permalink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="group block w-full h-full"
                        >
                          <div className="relative w-full h-full bg-gradient-to-br from-[#0A66C2]/5 to-[#0A66C2]/15">
                            {currentLiPost.image ? (
                              <img
                                key={currentLiPost.id}
                                src={currentLiPost.image}
                                alt="LinkedIn post"
                                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                                loading="lazy"
                              />
                            ) : (
                              <div className="w-full h-full flex items-center justify-center">
                                <FaLinkedinIn className="text-[#0A66C2] text-6xl opacity-20" />
                              </div>
                            )}

                            {/* Video badge */}
                            {currentLiPost.media_type === "VIDEO" && (
                              <span className="absolute top-3 right-3 bg-black/70 text-white text-[10px] font-medium px-2 py-1 rounded-full flex items-center gap-1">
                                <FaLinkedinIn size={10} /> Video
                              </span>
                            )}

                            {/* Caption overlay */}
                            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/85 via-black/55 to-transparent p-4 pt-10">
                              <p className="text-white text-[12.5px] leading-relaxed line-clamp-4">
                                {currentLiPost.caption
                                  ? currentLiPost.caption.slice(0, 200) +
                                    (currentLiPost.caption.length > 200 ? "..." : "")
                                  : "View post on LinkedIn"}
                              </p>
                              <p className="text-white/70 text-[10.5px] mt-1.5">
                                {currentLiPost.timestamp
                                  ? new Date(currentLiPost.timestamp).toLocaleDateString("en-IN", {
                                      day: "numeric",
                                      month: "short",
                                      year: "numeric",
                                    })
                                  : ""}
                              </p>
                            </div>
                          </div>
                        </a>

                        {liFeed.length > 1 && (
                          <>
                            <button
                              onClick={liPrev}
                              aria-label="Previous LinkedIn post"
                              className="absolute left-2 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center rounded-full bg-white/90 hover:bg-white text-[#0A66C2] shadow-md transition"
                            >
                              <FaChevronLeft size={12} />
                            </button>
                            <button
                              onClick={liNext}
                              aria-label="Next LinkedIn post"
                              className="absolute right-2 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center rounded-full bg-white/90 hover:bg-white text-[#0A66C2] shadow-md transition"
                            >
                              <FaChevronRight size={12} />
                            </button>
                          </>
                        )}
                      </div>

                      {liFeed.length > 1 && (
                        <div className="flex justify-center gap-1.5 mt-3 max-w-full overflow-hidden">
                          {liFeed.slice(0, 12).map((_, idx) => (
                            <button
                              key={idx}
                              onClick={() => setLiIndex(idx)}
                              aria-label={`Go to LinkedIn post ${idx + 1}`}
                              className={`h-1.5 rounded-full transition-all ${
                                idx === liIndex
                                  ? "w-5 bg-[#0A66C2]"
                                  : "w-1.5 bg-gray-300 hover:bg-gray-400"
                              }`}
                            />
                          ))}
                          {liFeed.length > 12 && (
                            <span className="text-[10px] text-gray-400 ml-1">
                              +{liFeed.length - 12}
                            </span>
                          )}
                        </div>
                      )}

                      <p className="text-center text-[11px] text-gray-400 mt-2">
                        {liIndex + 1} / {liFeed.length}
                      </p>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .press-loop {
          animation: pressScroll 90s linear infinite;
          will-change: transform;
        }
        .press-loop.paused {
          animation-play-state: paused;
        }
        @keyframes pressScroll {
          0% { transform: translateY(0); }
          100% { transform: translateY(-50%); }
        }
        @keyframes progress {
          from { width: 0%; }
          to { width: 100%; }
        }
        .line-clamp-4 {
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </section>
  );
}